import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/global.css';
import '../styles/Landing.css';

const AboutUs = () => (
  <div className="landing-bg" style={{ minHeight: '100vh' }}>
    <div className="landing-orbs">
      <div className="orb1" /><div className="orb2" /><div className="orb3" />
    </div>

    {/* NAV */}
    <nav className="navbar">
      <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
      <div className="nav-links">
        <Link to="/login" className="nav-a">Login</Link>
        <Link to="/register" className="btn-main" style={{ padding: '10px 22px', fontSize: 12 }}>Get Started ↗</Link>
      </div>
    </nav>

    <div style={{ maxWidth: 720, margin: '0 auto', padding: '80px 24px 60px' }}>
      <div className="tag" style={{ marginBottom: 20, display: 'inline-flex' }}>About Us</div>
      <h1 style={{ fontSize: 42, fontWeight: 800, marginBottom: 16, lineHeight: 1.2 }}>
        We're building the <em>simplest</em> link in bio tool.
      </h1>
      <p style={{ color: 'var(--muted)', fontSize: 16, lineHeight: 1.8, marginBottom: 40 }}>
        mylinx started with a simple question — why should creators pay $9/month for something that should be free?
      </p>

      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 40, marginBottom: 40 }}>
        <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 16 }}>Our Story</h2>
        <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.9, marginBottom: 16 }}>
          mylinx was built by Vikas Tomar, a developer from India who was tired of paying for Linktree. In early 2026, he built the first version over a weekend — and it went live within days.
        </p>
        <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.9 }}>
          Today, 500+ creators use mylinx to share their links, collect emails from followers, protect exclusive content, and understand their audience — all for free.
        </p>
      </div>

      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 40, marginBottom: 40 }}>
        <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 24 }}>What we believe</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
          {[
            { icon: '🆓', title: 'Free should mean free', desc: 'Core features are free forever. No bait and switch. No hidden fees.' },
            { icon: '🔒', title: 'Your data is yours', desc: 'We never sell your data or your subscribers\' emails. Ever.' },
            { icon: '🇮🇳', title: 'Built for Indian creators', desc: 'INR pricing, Razorpay support, and a product that understands the Indian creator economy.' },
            { icon: '🚀', title: 'Ship fast, fix faster', desc: 'We move fast and respond to every support email personally.' },
          ].map((item, i) => (
            <div key={i} style={{ background: 'var(--link-bg)', border: '1px solid var(--border)', borderRadius: 12, padding: 20 }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{item.icon}</div>
              <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>{item.title}</div>
              <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7 }}>{item.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 40 }}>
        <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 16 }}>Get in touch</h2>
        <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.8, marginBottom: 20 }}>
          We'd love to hear from you — feature requests, feedback, or just a hello.
        </p>
        <a href="mailto:support@mylinx.in" style={{
          display: 'inline-block', background: 'var(--accent)', color: '#fff',
          padding: '12px 24px', borderRadius: 10, textDecoration: 'none',
          fontWeight: 700, fontSize: 14,
        }}>
          📧 support@mylinx.in
        </a>
      </div>
    </div>

    <footer className="footer">
      <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
      <div className="footer-copy">MADE WITH OBSESSION © 2026</div>
      <div className="footer-links">
        <Link to="/about" className="footer-a">About</Link>
        <Link to="/contact" className="footer-a">Contact</Link>
        <Link to="/terms" className="footer-a">Terms</Link>
        <Link to="/privacy" className="footer-a">Privacy</Link>
        <Link to="/refund" className="footer-a">Refund</Link>
      </div>
    </footer>
  </div>
);

export default AboutUs;